import { Injectable } from '@angular/core';
import { YoklamaStateService } from './yoklama_state_service';
import { TimerService } from './timer_services';
import { SignalRService } from './signalr_service';
import { AttendanceService } from 'app/services/yoklama/attendance.service';
import { QrService } from 'app/services/yoklama/qr.service';
import { UtcTimeService } from 'app/services/yoklama/utc-time.service';

import { AttendanceSlot, AttendanceState, Student, UiState } from './app_state';
import { StudentModel } from './yoklama_models';
import { CMSDynamicService } from 'app/services/yoklama/cms-service';
import {
  CustomToastrService,
  ToastrMessageType,
  ToastrPosition,
} from 'app/base/services/custom-toast-service';
import { environment } from 'environments/environment';
import { Router } from '@angular/router';
import { Console } from 'console';
import { on } from 'events';

@Injectable({ providedIn: 'root' })
export class YoklamaFacade {
  state$ = this.state.state$;

  constructor(
    public state: YoklamaStateService,
    private timer: TimerService,
    private signalR: SignalRService,
    private api: AttendanceService,
    private qr: QrService,
    private utc: UtcTimeService,
    private httpService: CMSDynamicService,
    private alertsService: CustomToastrService,
    private route: Router

  ) {}

  // ================= INIT =================

  async init() {
    this.state.setUi({ loading: true });

    // 🔥 SADECE BU
    this.state.hydrate();

    const s = this.state.getState();



    if (s.course.courseId) {
      console.log('course id geldi', s.course.courseId);
    } else {
      console.log('course id gelmedi');

      window;
    }

    this.state.setUi({ loading: false, connection: true });

    this.state.generateSlots();
  }

  private isListening = false;

  private listenSignalR() {
    // 🛡️ Eğer zaten dinliyorsak tekrar listener ekleme (Memory Leak engelleme)
    if (this.isListening) return;
    this.isListening = true;



    // ================= QR =================
    this.signalR.onNewToken(async (data) => {
      const s = this.state.getState();

      this.state.setUi({
        qrToken: data.token,
        konumKontrol: data.konumKontrolAktif,
      });

      if (s.ui.qrUret) {
        const qr = await this.qr.generateAttendanceQr({
          token: data.token,
          courseStartId: data.courseStartId,
          courseId: data.courseStartId,
          teacherId: s.course.akademikPersonelNo?.toString() ?? '',
          slotCount: data.slotCount ?? s.attendance.slotCount,
          slotNumber: data.slotNumber,
          haftalikDersId: s.course.haftalikDersId,
          acilanDersDetayNo: s.course.acilanDersDetayNo ?? 0,
          akademikPersonelNo: s.course.akademikPersonelNo,
          acilanDersNo: s.course.acilanDersNo,
          obsStatus: false,
          konumDisi: !data.konumKontrolAktif,
          yoklamaNo: String(s.course.haftalikDersId ?? ''),
        });
        this.state.setUi({ qrBase64: qr });
      }
    });

    // ================= QR EXPIRED =================
    this.signalR.onQrExpired(() => {
      this.state.setUi({
        qrBase64: null,
        qrToken: null,
      });
    });

    // ================= ATTENDANCE =================
    /*  this.signalR.onAttendanceUpdate((apiStudents) => {
      const s = this.state.getState();
      let students = [...s.attendance.students];

      console.log('🎯 Attendance güncellemesi geldi:', apiStudents);

      apiStudents.forEach((st) => {
        students = this.updateStudentInState(
          st,
          st.attendance[0],
          s.attendance.yoklamaPeriyodu,
          s.attendance.aktifSlotIndex,
          s.attendance.totalSessionHours,
          students,
        );
      });

      this.state.setAttendance({
        students: students,
        aktifSlotIndex: s.attendance.aktifSlotIndex,
        slotCount: s.attendance.slotCount,
      });
    });
 */
    // ================= ATTENDANCE EXPIRED =================
    /*  this.signalR.onAttendanceExpired(() => {
      console.warn('⛔ Yoklama süresi doldu');
      this.state.setUi({
        yoklamaBasladi: false,
      });
    }); */
  }

  // ================= COURSE =================

  async startCourse() {
    try {
      this.state.setUi({ loading: true });

      const s = this.state.getState();

      if (s.attendance.attendanceDuration == null) {
        this.alertsService.message('Lütfen yoklama süresini seçin.', 'Uyarı');
        return;
      }


      if (
        s.attendance.yoklamaPeriyodu !== 'teksefer' &&
        s.attendance.aktifSlotIndex === -1
      ) {
        this.alertsService.message('En az bir saat seçmelisiniz.', 'Uyarı');
        return;
      }
      if (s.ui.konumKontrol && (!s.ui.latitude || !s.ui.longitude)) {
        this.alertsService.message(
          'Şu an sadece yerleşke seçili, lütfen konum seçiniz',
          'Uyarı',
        );
        return;
      }
      const utc = await this.utc.fetchUtcTime();

      const payload = {
        courseId: s.course.courseId,
        teacherId: s.course.akademikPersonelNo?.toString(),

        startTime: utc?.toISOString() ?? new Date().toISOString(),
        attendanceEndTime: s.course.dersBitis ?? new Date().toISOString(),

        locationLatitude: s.ui.latitude ?? 0,
        locationLongitude: s.ui.longitude ?? 0,

        attendanceDuration: s.attendance.attendanceDuration,
        slotCount: s.attendance.slotCount,
        totalSessionHours: s.attendance.totalSessionHours,

        haftalikDersId: s.course.haftalikDersId,
        attendanceMode: s.attendance.yoklamaPeriyodu,

        qrUretimAktif: s.ui.qrUret,
        konumKontrolAktif: s.ui.konumKontrol,

        ObsStatus: false,

        acilanDersDetayNo: s.course.acilanDersDetayNo,
        akademikPersonelNo: s.course.akademikPersonelNo,
        acilanDersNo: s.course.acilanDersNo,
        gun: s.course.gun,
      };

      const res = await this.api.startCourse(payload);

      if (res) {
        const data = res;


        // 🔥 COURSE UPDATE
        this.state.startLesson({
          courseStartId: data.id || 0,
          haftalikDersId: data.haftalikDersId ?? 0,
          acilanDersDetayNo: data.acilanDersDetayNo ?? 0,
          akademikPersonelNo: data.akademikPersonelNo ?? 0,
          acilanDersNo: data.acilanDersNo ?? 0,
          dersBaslangic: s.course.dersBaslangic,
        });

        // 🔥 ATTENDANCE UPDATE
        this.state.setAttendance({
          students: (data.attendanceInfo?.ogrenciler || []).map((x: any) =>
            this.state.mapApiStudentToState(x, s.attendance.totalSessionHours),
          ),
          slotCount: payload.slotCount,
          totalSessionHours: payload.totalSessionHours,
          attendanceDuration: payload.attendanceDuration,
        });
        // 🔥 TIMER BURADA BAŞLAMALI

        // 🔥 UI UPDATE
        this.state.setUi({
          qrToken: data.token ?? s.ui.qrToken,
          baslat: true,
        });
        this.startSlot();
        if (data.token) {

          const qr = await this.qr.generateAttendanceQr({
            token: data.token,
            courseStartId: data.id,
            courseId: data.id,
            teacherId: s.course.akademikPersonelNo?.toString() ?? '',
            slotCount: payload.slotCount,
            slotNumber: payload.totalSessionHours - payload.slotCount,
            haftalikDersId: s.course.haftalikDersId,
            acilanDersDetayNo: s.course.acilanDersDetayNo ?? 0,
            akademikPersonelNo: s.course.akademikPersonelNo,
            acilanDersNo: s.course.acilanDersNo,
            obsStatus: false,
            konumDisi: !payload.konumKontrolAktif,
            yoklamaNo: String(s.course.haftalikDersId ?? ''),
          });

          this.state.setUi({
            qrBase64: qr,
          });
        }
        const signalRPayload = {
          courseId: payload.courseId,
          haftalikDersId: payload.haftalikDersId,
          slotNumber:
            s.attendance.aktifSlotIndex >= 0 ? s.attendance.aktifSlotIndex : 0,
          yoklamaSuresi: payload.attendanceDuration,
          qrUret: payload.qrUretimAktif,
          konumKontrol: payload.konumKontrolAktif,
          acilanDersDetayNo: payload.acilanDersDetayNo,
          akademikPersonelNo: payload.akademikPersonelNo,
          acilanDersNo: payload.acilanDersNo,
        };
        // 🔥 SIGNALR
        await this.signalR.connectQrHub(data.id, signalRPayload);
        /*   await this.signalR.connectAttendanceHub(
          data.id,
          payload.attendanceDuration,
        ); */

        this.listenSignalR();
      }
    } catch (err) {
      this.state.setUi({ error: 'Ders başlatılamadı' });
    } finally {
      this.state.setUi({ loading: false });
    }
  }

  async updateCourse() {
    const s = this.state.getState();
    if (s.attendance.attendanceDuration == null) {
      this.alertsService.message('Lütfen yoklama süresini seçin.', 'Uyarı');
      return;
    }

    if (
      s.attendance.yoklamaPeriyodu !== 'teksefer' &&
      s.attendance.aktifSlotIndex === -1
    ) {
      this.alertsService.message('En az bir saat seçmelisiniz.', 'Uyarı');
      return;
    }
    const payload = {
      id: s.course.courseStartId || 0,
      courseId: s.course.courseId,

      teacherId: String(s.course.akademikPersonelNo),

      startTime: new Date(s.course.dersBaslangic ?? new Date()).toISOString(),
      attendanceEndTime: new Date(
        s.course.dersBitis ?? new Date(),
      ).toISOString(),

      attendanceDuration: s.attendance.attendanceDuration,
      slotCount: s.attendance.slotCount,

      totalSessionHours: s.attendance.totalSessionHours,
      haftalikDersId: s.course.haftalikDersId,
      attendanceMode: s.attendance.yoklamaPeriyodu,
      locationLatitude: s.ui.latitude ?? 0,
      locationLongitude: s.ui.longitude ?? 0,
      qrUretimAktif: s.ui.qrUret,
      konumKontrolAktif: s.ui.konumKontrol,

      ObsStatus: false,

      acilanDersDetayNo: s.course.acilanDersDetayNo,
      akademikPersonelNo: s.course.akademikPersonelNo,
      acilanDersNo: s.course.acilanDersNo,
      gun: s.course.gun,
    };

    const res = await this.api.updateCourse(payload);

    if (!res?.id) return;

    const data = res;
    if (data.token) {

      const qr = await this.qr.generateAttendanceQr({
        token: data.token,
        courseStartId: data.id,
        courseId: data.id,
        teacherId: s.course.akademikPersonelNo?.toString() ?? '',
        slotCount: payload.slotCount,
        slotNumber: payload.totalSessionHours - payload.slotCount,
        haftalikDersId: s.course.haftalikDersId,
        acilanDersDetayNo: s.course.acilanDersDetayNo ?? 0,
        akademikPersonelNo: s.course.akademikPersonelNo,
        acilanDersNo: s.course.acilanDersNo,
        obsStatus: false,
        konumDisi: !payload.konumKontrolAktif,
        yoklamaNo: String(s.course.haftalikDersId ?? ''),
      });

      this.state.setUi({
        qrBase64: qr,
      });
    }
    // 🔥 COURSE UPDATE
    this.state.startLesson({
      courseStartId: data.id,
      haftalikDersId: data.haftalikDersId ?? s.course.haftalikDersId,
      acilanDersDetayNo: data.acilanDersDetayNo ?? 0,
      akademikPersonelNo: data.akademikPersonelNo ?? 0,
      acilanDersNo: data.acilanDersNo ?? 0,
    });

    // 🔥 ATTENDANCE UPDATE
    this.state.setAttendance({
      slotCount: payload.slotCount,
      attendanceDuration: payload.attendanceDuration,
      totalSessionHours: payload.totalSessionHours,
    });

    // 🔥 UI UPDATE
    this.state.setUi({
      qrToken: data.token ?? '',
    });
    // 🔥 ÖNEMLİ: HUB RECONNECT
    await this.signalR.disconnectAll();

    await this.signalR.connectQrHub(res.id, {
      ...payload,
      slotNumber: s.attendance.aktifSlotIndex ?? 0,
      yoklamaSuresi: s.attendance.attendanceDuration,
      qrUret: s.ui.qrUret,
      konumKontrol: s.ui.konumKontrol,
    });

    /*   await this.signalR.connectAttendanceHub(
      res.id,
      s.attendance.attendanceDuration,
    ); */

    // event listener tekrar bağlanır
    this.listenSignalR();
    // 🔥 TIMER BURADA BAŞLAMALI
    this.startSlot();
  }
  setSearch(value: string) {
    this.state.setUi({ search: value });
  }

  async endLesson() {
    const s = this.state.getState();

    await this.api.updateCourse({
      courseStartId: s.course.courseStartId,
      dersBitis: new Date().toISOString(),
    });

    this.state.endLesson();
    this.timer.stop();
  }
  startYoklama() {
    // UI state güncelle
    this.state.setUi({
      currentStep: 2,
      baslat: true,
    });

    const s = this.state.getState();

    if (s.ui.konumKontrol) {
    }
  }
  normalizeId = (x: any) => Number(x);

  private updateStudentInState(
    student: Student,
    opts: { katildiMi: boolean; konumDisi: boolean },
    attendancePeriyodu: 'teksefer' | 'saatbasi',
    aktifSlotIndex: number,
    totalSessionHours: number,
    studentsList: Student[],
  ): Student[] {
    const slotNumber =
      attendancePeriyodu === 'teksefer' ? 0 : aktifSlotIndex + 1;

    const sid = this.normalizeId(student.studentId ?? student.id);


    return studentsList.map((st) => {
      const currentId = this.normalizeId(st.studentId ?? st.id);

      if (currentId !== sid) {
        return st;
      }

      const attendance = Array.isArray(st.attendance) ? [...st.attendance] : [];

      let updatedAttendance: AttendanceSlot[] = [];

      // 🔥 TEK SEFER → FULL OVERRIDE
      if (attendancePeriyodu === 'teksefer') {
        updatedAttendance = attendance.map((s) => ({
          ...s,
          katildiMi: opts.katildiMi,
          konumDisi: opts.konumDisi,
        }));
      }

      // 🔥 SAAT BAŞI → SLOT BASED UPDATE
      else {
        const index = attendance.findIndex((s) => s.slotNumber === slotNumber);

        if (index >= 0) {

          updatedAttendance = attendance.map((s) =>
            s.slotNumber === slotNumber
              ? {
                  ...s,
                  katildiMi: opts.katildiMi,
                  konumDisi: opts.konumDisi,
                }
              : s,
          );
        } else {

          updatedAttendance = [
            ...attendance,
            {
              slotNumber,
              katildiMi: opts.katildiMi,
              konumDisi: opts.konumDisi,
            },
          ];
        }
      }

      return {
        ...st,
        attendance: updatedAttendance,
      };
    });
  }

  updateStudentStatus(
    student: Student,
    opts: { katildiMi: boolean; konumDisi: boolean },
  ) {
    const s = this.state.getState();
    const course = s.course;
    const attendance = s.attendance;
    const ui = s.ui;
    const slotCount = attendance.slotCount;

    const slotNumber =
      attendance.yoklamaPeriyodu === 'teksefer'
        ? 1
        : attendance.aktifSlotIndex + 1;

    const payload: any = {
      course_startId: course.courseStartId,
      studentId: String(student.id),
      qrRead: false,
      konumDisi: opts.konumDisi,
      ogrenciDersNo: Number(student.ogrenciNo),
      teacherId: course.akademikPersonelNo?.toString(),
      slotCount: slotCount,
      slotNumber: slotNumber,
      haftalikDersId: course.haftalikDersId,
      yoklamaNo: course.haftalikDersId,
      isAllSlotsTaken: attendance.yoklamaPeriyodu === 'teksefer',
      courseId: course.courseStartId, //burda basatan sona bir inceleme gerekli gibi duruyor
      obsStatus: false,
      token: ui.qrToken ?? '0',
      katildimi: opts.katildiMi,
      studentName: student.adSoyad?.split(' ')[0] || '',
      studentSurname: student.adSoyad?.split(' ')[1] || '',
      acilanDersDetayNo: course.acilanDersDetayNo,
      akademikPersonelNo: course.akademikPersonelNo,
      acilanDersNo: course.acilanDersNo,
      tokenBak: false,
      attendanceSource: 'teacher_manual',
    };

    const queryString = Object.keys(payload)
      .map((k) => `${encodeURIComponent(k)}=${encodeURIComponent(payload[k])}`)
      .join('&');

    this.httpService
      .getBasic('Yoklama', 'AddAttendanceRecord', queryString)
      .then((res) => {
        const updatedStudents = this.updateStudentInState(
          student,
          opts,
          attendance.yoklamaPeriyodu,
          attendance.aktifSlotIndex,
          attendance.totalSessionHours,
          attendance.students,
        );

        this.state.setAttendance({
          students: updatedStudents,
          aktifSlotIndex: attendance.aktifSlotIndex,
          slotCount: slotCount,
        });

      })
      .catch((err) => console.error('sendAttendance error', err));
  }
  getFilteredStudents() {
    const s = this.state.getState();

    const search = s.ui.search?.toLowerCase() || '';

    return s.attendance.students.filter((st) => {
      const name = (st.adSoyad || '').toLowerCase();
      const no = (st.studentId || '').toString();

      return name.includes(search) || no.includes(search);
    });
  }
  geri() {
    // UI state güncelle
    this.state.setUi({
      currentStep: 1,
      baslat: false,
    });
  }
  // ================= SLOT =================
  // component’ten çağırılır
  setKampusKonum(lat: number, lng: number) {
    this.state.setKampusKonum(lat, lng);
  }

  setBinaKonum(lat: number, lng: number) {
    this.state.setBinaKonum(lat, lng);
  }

  getKampusKonum() {
    return this.state.getKampusKonum();
  }

  getBinaKonum() {
    return this.state.getBinaKonum();
  }
  startSlot() {

    this.timer.stop(); // 🔥 KRİTİK
    const s = this.state.getState();

    const endTime = Date.now() + s.attendance.attendanceDuration * 60 * 1000;

    this.state.setUi({
      qrExpireAt: endTime,
      modalOpen: true,
      kalanSure: s.attendance.attendanceDuration * 60,
    });

    this.timer.start(endTime, (remaining) => {
      this.state.setUi({ kalanSure: remaining });

      if (remaining === 0) {


        // 🔥 1. QR temizle
        this.state.setUi({
          qrBase64: null,
          qrToken: null,
        });

        // 🔥 2. modal kapat
        this.state.setUi({
          modalOpen: false,
        });

        // 🔥 3. slot ilerlet
        //  this.nextSlot();
        this.onSlotFinished();
        // 🔥 4. SON SLOT KONTROLÜ
      }
    });
  }
  async onSlotFinished() {
    // 1. UI temizle
    this.state.setUi({
      qrBase64: null,
      qrToken: null,
      modalOpen: false,
    });

    // 2. backend’den fresh data çek
    try {
      const s = this.state.getState();
      const formatTime = (date: any) => {
  if (!date) return '';

  const d = new Date(date);

  const hours = String(d.getHours()).padStart(2, '0');
  const minutes = String(d.getMinutes()).padStart(2, '0');

  return `${hours}:${minutes}`;
};
     const baslangic = formatTime(s.course.dersBaslangic);
const bitis = formatTime(s.course.dersBitis);
      const res = await this.api.getAttendanceList(
        s.course.courseStartId || 0,
        s.course.acilanDersNo || 0,
        s.course.haftalikDersId || 0,
        baslangic,
        bitis,
      );



      // 3. state update (EN KRİTİK KISIM)
      this.state.setAttendance({
        students: (res || []).map((x: any) =>
          this.state.mapApiStudentToState(x, s.attendance.totalSessionHours),
        ),
        slotCount: s.attendance.slotCount,
        totalSessionHours: s.attendance.totalSessionHours,
        attendanceDuration: s.attendance.attendanceDuration,
      });
    } catch (err) {
      console.error('Timer bitince liste çekilemedi:', err);
    }

    // 4. slot ilerlet
    this.handleSlotFinished();
  }

  private handleSlotFinished() {
    const s = this.state.getState();

    // ✅ TEKSEFER MODE
    if (s.attendance.yoklamaPeriyodu === 'teksefer') {
      // 🔥 SLOT STATE NORMALIZE
      const slots = s.attendance.slots.map((slot) => ({
        ...slot,
        active: true,
      }));

      this.state.setAttendance({
        slots,
        aktifSlotIndex: 0,
        slotCount: 0,
      });

      // 🔥 UI + LESSON END
      this.state.setUi({
        yoklamaBasladi: false,
        coursePhase: 'ended',
      });

      this.state.endLesson();
      this.timer.stop();

      return;
    }

    // ================= NORMAL SLOT =================

    const total = s.attendance.totalSessionHours;
    const current = s.attendance.aktifSlotIndex;
    const next = current + 1;

    if (next >= total) {


      this.state.setUi({
        yoklamaBasladi: false,
        coursePhase: 'ended',
      });

      this.state.endLesson();
      this.timer.stop();
      return;
    }
    ///bir sonraki slota geçiliyor
    /*   const slots = [...s.attendance.slots];

  slots[next].active = true;

  this.state.setAttendance({
    slots,
    aktifSlotIndex: next,
    slotCount: total - (next + 1),
  }); */

    this.state.setUi({
      coursePhase: 'running',
    });


  }

  nextSlot() {
    const state = this.state.getState();

    const current = state.attendance.aktifSlotIndex;

    const next = current + 1;

    if (next >= state.attendance.totalSessionHours) {
      // 🔥 ders bitti
      this.state.setAttendance({
        dersbasldimi: false,
        slotCount: 0,
      });

      return;
    }

    const slots = [...state.attendance.slots];

    slots[next].active = true;

    this.state.setAttendance({
      slots,
      aktifSlotIndex: next,
      slotCount: state.attendance.totalSessionHours - (next + 1),
    });
  }

  // ================= SLOT GENERATOR (EKSİK PARÇA TAMAMLANDI) =================

  // ================= STUDENT =================

  async markPresent(studentId: number, slot: number) {
    const s = this.state.getState();

    this.state.updateStudent(studentId, slot, {
      katildiMi: true,
      konumDisi: false,
    });

    await this.api.sendAttendance({
      studentId,
      slotNumber: slot,
      katildiMi: true,
      courseStartId: s.course.courseStartId,
    });

    this.signalR.sendStudentUpdate({
      studentId,
      slot,
      katildiMi: true,
      konumDisi: false,
    });
  }

  async markAbsent(studentId: number, slot: number) {
    const s = this.state.getState();

    this.state.updateStudent(studentId, slot, {
      katildiMi: false,
    });

    await this.api.sendAttendance({
      studentId,
      slotNumber: slot,
      katildiMi: false,
      courseStartId: s.course.courseStartId,
    });
  }

  // ================= OBS =================
  // 🔥 EKSTRA (opsiyonel ama temiz kullanım)
  setLocation(lat: number, lng: number) {
    this.state.setUi({
      latitude: lat,
      longitude: lng,
    });
  }

  // OBS'ye aktarma
  obsAktar() {
    const s = this.state.getState();

    var courseStartId = s.course.courseStartId;
    var totalSessionCount = s.attendance.totalSessionHours;
    var weeklyCourseId = s.course.haftalikDersId;
    var yoklamaPeriyodu = s.attendance.yoklamaPeriyodu;

    var url =
      environment.baseUrl +
      '/Kapi/YoklamaListeGetir?courseStartId=' +
      courseStartId.toString() +
      '&yoklamaNo=' +
      weeklyCourseId.toString() +
      '&yoklamaMod=' +
      yoklamaPeriyodu +
      '&dersSaati=' +
      totalSessionCount.toString();
    this.httpService.getUrl(url).then((response) => {
      if (response) {


        this.alertsService.message('OBS Yoklama Aktarımı Başarılı', 'Uyarı', {
          messageType: ToastrMessageType.Success,
          position: ToastrPosition.TopFullWidth,
        });

        this.route.navigate(['/hoca-ders-programi']);
      } else {
        console.warn("OBS'ye aktarma başarısız, boş response");
        this.alertsService.message('OBS Yoklama Aktarımı Başarısız', 'Uyarı', {
          messageType: ToastrMessageType.Error,
          position: ToastrPosition.TopFullWidth,
        });
      }
    });
  }

  // ================= QR =================

  async generateQr() {
    const s = this.state.getState();



    const qrBase64 = await this.qr.generateAttendanceQr({
      token: 'QR-' + Date.now(),
      courseStartId: s.course.courseStartId,
      courseId: s.course.courseStartId,
      teacherId: s.course.akademikPersonelNo.toString(),
      slotCount: s.attendance.slotCount,
      slotNumber:
        s.attendance.yoklamaPeriyodu === 'saatbasi'
          ? s.attendance.aktifSlotIndex
          : 0,
      haftalikDersId: s.course.haftalikDersId,
      acilanDersDetayNo: 0,
      akademikPersonelNo: s.course.akademikPersonelNo,
      acilanDersNo: 0,
      obsStatus: false,
      konumDisi: false,
      yoklamaNo: s.course.haftalikDersId.toString(),
    });

    this.state.setUi({
      qrBase64,
      qrToken: 'QR-' + Date.now(),
    });
  }
  setUi(data: Partial<UiState>) {
    this.state.setUi(data);
  }
  setAttendance(data: Partial<AttendanceState>) {
    this.state.setAttendance(data);
  }

  setSlotActive(index: number, value: boolean) {
    const state = this.state.getState();

    const slots = [...state.attendance.slots];

    // slot güncelle
    slots[index] = {
      ...slots[index],
      active: value,
    };

    // aktif slot index listesi
    const activeIndexes = slots
      .map((s, i) => (s.active ? i : -1))
      .filter((i) => i !== -1);

    // ✅ SON SEÇİLEN SLOT
    const aktifSlotIndex =
      activeIndexes.length > 0 ? activeIndexes[activeIndexes.length - 1] : -1;

    // ✅ AKTİF SLOT SAYISI
    const activeCount = activeIndexes.length;

    // ✅ SENİN MODEL: KALAN SLOT
    const total = slots.length;
    const slotCount = total - activeCount;


    this.state.setAttendance({
      slots,
      aktifSlotIndex,
      slotCount,
    });
  }
  // ================= RESET =================

  reset() {
    this.timer.stop();
    this.state.reset();
  }
  openModal(data: { kalanSure: any; qrBase64: any; qrUret: any }) {
    this.state.setUi({
      modalOpen: true,
      kalanSure: data.kalanSure,
      qrBase64: data.qrBase64,
      qrUret: data.qrUret,
    });
  }

  closeModal() {
    this.state.setUi({ modalOpen: false });
  }
}
